import { render } from "./OfficeNews.vue?vue&type=template&id=58f2aa81"
import script from "./OfficeNews.vue?vue&type=script&lang=js"
export * from "./OfficeNews.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__